import { CountryCodeEnum } from '../../enums/shared/country-code.enum';

/**
 * The list of french tax countries
 */
export const frenchTaxCountries = [
  CountryCodeEnum.FR,
  CountryCodeEnum.GP,
  CountryCodeEnum.MQ,
  CountryCodeEnum.GF,
  CountryCodeEnum.RE,
  CountryCodeEnum.YT,
];
